/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */

import EmailTemplateList from './pages/EmailTemplateList.vue';
import SaveEmailTemplate from './pages/SaveEmailTemplate.vue';
import EditEmailTemplate from './pages/EditEmailTemplate.vue';

export default {
  'apcwo-email-template-list': EmailTemplateList,
  'apcwo-email-template-save': SaveEmailTemplate,
  'apcwo-email-template-edit': EditEmailTemplate,
};
